import { createSelector } from 'reselect';

const selectState = (state) => state.get('dialogSavedTemplatesSelector');

const makeSelectSavedTemplates = () =>
  createSelector(
    selectState,
    (state) => state && state.get('savedTemplates'),
  );

const makeSelectSearching = () =>
  createSelector(
    selectState,
    (state) => state && state.get('searching'),
  );

export { makeSelectSavedTemplates, makeSelectSearching };
